import { faStar as faStarEmpty } from "@fortawesome/pro-regular-svg-icons";
import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

export default function TemplateListItem({
  template,
  onClick,
  onFavouriteToggle,
  icon,
  dataTestId,
}) {
  const handleStarClick = (e) => {
    e.stopPropagation(); // Prevent triggering the parent onClick
    e.preventDefault(); // Prevent triggering two alerts
    onFavouriteToggle(template.uuid);
  };
  return (
    <div
      className="relative flex-none flex flex-row bg-white dark:bg-gray-700 px-4 py-2 rounded-xl shadow-sm cursor-pointer hover:bg-indigo-50 dark:hover:bg-gray-600/80 transition-colors"
      key={template.uuid}
      data-testid={dataTestId}
      onClick={onClick}
    >
      <div className="flex flex-row gap-2 items-center w-full">
        <FontAwesomeIcon
          icon={icon}
          size="2x"
          className="text-indigo-500 mt-1"
        />
        <div className="flex flex-col w-full min-w-px">
          <div className="flex flex-row items-center justify-between mb-1">
            <span className="text-sm font-medium truncate max-w-xs">
              {template.name}
            </span>
            {template.templateType !== "SCRIBENOTE_DEFAULT" && (
              <div className="ml-2">
                <label
                  className={
                    "cursor-pointer text-yellow-500 hover:text-yellow-600"
                  }
                  onClick={handleStarClick}
                  data-testid="favorite-star"
                >
                  <input
                    type="checkbox"
                    className="sr-only"
                    checked={template.isFavourite}
                    onChange={() => {}} // Required to avoid React warning
                  />
                  <FontAwesomeIcon
                    icon={template.isFavourite ? faStar : faStarEmpty}
                  />
                </label>
              </div>
            )}
          </div>
          <p className="text-xs w-full line-clamp-2">
            {template.description}
          </p>

          <div className="flex flex-row items-center justify-between">
            {template.createdAt && (
              <div className="mt-1 text-gray-500 text-xs dark:text-gray-400">
                {moment(template.createdAt).format("MMM DD, YYYY")}
              </div>
            )}

            {template?.user && (
              <div className="text-xs text-gray-500 dark:text-gray-300">
                {template.user.firstName} {template.user.lastName}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
